export const USER_PROFILE_REQUEST = "user/userProfileRequest";
export const USER_PROFILE_SUCCESS = "user/userProfileSuccess";
export const USER_PROFILE_ERROR = "user/userProfileError";